const keys = {
  /* API  secreates keys*/

  IPSTACK_KEY: "395511039ebc943c81cbdbcdc087f684",

  /******** local keys  *******/

  /* common keys */

  ENGLISH: "English",
  HINDI: "Hindi",

  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",

  GROOM_SIDE: "groom",
  BRIDE_SIDE: "bride",

  /* related to user */

  DEVICE_INFO: "device_info",
  WEB: "web",
  COUNTRY_NAME: "country_name",
  PLATFORM: "Invitation-Panda-Website",
  COUNTRY: "country",
  COUNTRY_CODE: "country_code",

  /* related to cards*/
  INVITATION: "invitation",
  GREETING: "greeting",
  PDF_CARD: "pdf_card",
  VIDEO_CARD: "video_card",
  DRAFT: "draft",
  PURCHASED: "purchased"
};

export default keys;
